import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './Loader.scss';

export const Loader = ({
    hideTitle,
    title = 'Loading...',
    size = 'large',
    variant = 'default',
    centered = false,
    className,
    ...props
}) => {
    const loaderClass = classNames(
        styles['loading-element'],
        size && styles[`loading-element-${size}`],
        variant && styles[`loading-element-${variant}`],
        centered && styles['loading-element-centered'],
        className,
    );

    const titleNode = hideTitle ? null : (
        <p className="text-center">{ title }</p>
    );

    return (
        <div className={loaderClass} {...props}>
            <div className={styles['loader-container']} />
            { titleNode }
        </div>
    );
};

Loader.propTypes = {
    hideTitle: PropTypes.bool,
    title: PropTypes.string,
    size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large']),
    variant: PropTypes.oneOf(['default', 'inline', 'overlay']),
    centered: PropTypes.bool,
    className: PropTypes.string,
};

// Backward compatibility export
export const LoadingElement = Loader;

export default Loader;

